import { ADD_TO_CART, DECREMENT_ITEM, INCREMENT_ITEM } from "./actionTypes";

let productData = [
  {
    id: 1,
    productName: "Asus Vivobook X515MA",
    stock: 10,
    price: 35500,
  },
  {
    id: 2,
    productName: "Dell E1916HV 18.5 Inch",
    stock: 2,
    price: 9300,
  },
  {
    id: 3,
    productName: "Canon Eos 4000D 18MP",
    stock: 5,
    price: 36500,
  },
];

const initialState = {
  products: productData,
  cart: [],
};

const cartReducer = (state = initialState, action) => {
  const matchedItem = state?.products.find(
    (item) => item?.id === action?.payload?.id
  );
  const alreadyInCart = state?.cart.find(
    (item) => item?.id === action?.payload?.id
  );

  switch (action.type) {
    case ADD_TO_CART:
      return {
        ...state,
        cart: alreadyInCart
          ? state?.cart.map((item) =>
              item?.id === action?.payload?.id
                ? {
                    ...item,
                    quantity: item?.quantity + 1,
                  }
                : item
            )
          : [...state.cart, { ...matchedItem, quantity: 1 }],
        products: matchedItem
          ? state?.products.map((item) =>
              item?.id === action?.payload?.id
                ? { ...item, stock: item?.stock - 1 }
                : item
            )
          : [...state.products],
      };

    case INCREMENT_ITEM:
      return {
        ...state,
        cart: alreadyInCart
          ? state?.cart.map((item) =>
              item?.id === action?.payload?.id
                ? { ...item, quantity: item?.quantity + 1 }
                : item
            )
          : [...state.cart, { ...matchedItem, quantity: 1 }],
        products: matchedItem
          ? state?.products.map((item) =>
              item?.id === action?.payload?.id
                ? { ...item, stock: item?.stock - 1 }
                : item
            )
          : [...state.products],
      };
    case DECREMENT_ITEM:
      if (alreadyInCart?.quantity === 1) {
        return {
          ...state,
          cart: state.cart.filter((item) => item.id !== action.payload.id),
          products: matchedItem
            ? state?.products.map((item) =>
                item?.id === action?.payload?.id
                  ? { ...item, stock: item?.stock + 1 }
                  : item
              )
            : [...state.products],
        };
      }
      return {
        ...state,
        cart: alreadyInCart
          ? state?.cart.map((item) =>
              item?.id === action?.payload?.id
                ? { ...item, quantity: item?.quantity - 1 }
                : item
            )
          : [...state.cart, { ...matchedItem, quantity: 0 }],
        products: matchedItem
          ? state?.products.map((item) =>
              item?.id === action?.payload?.id
                ? { ...item, stock: item?.stock + 1 }
                : item
            )
          : [...state.products],
      };
    default: {
      return state;
    }
  }
};

export default cartReducer;
